import { render, staticRenderFns } from "./Evaluate2.vue?vue&type=template&id=13489c78&scoped=true&"
import script from "./Evaluate2.vue?vue&type=script&lang=js&"
export * from "./Evaluate2.vue?vue&type=script&lang=js&"
import style0 from "./Evaluate2.vue?vue&type=style&index=0&id=13489c78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13489c78",
  null
  
)

export default component.exports